





































































































































































































































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { inject } from 'inversify-props';
import { isArray, sortBy } from 'lodash';
import { AgGridVue } from '@ag-grid-community/vue';
import {
  GridReadyEvent,
  IServerSideDatasource,
  IServerSideGetRowsParams,
  SelectionChangedEvent,
  ValueFormatterParams,
  ValueGetterParams,
} from '@ag-grid-community/core';
import { plainToClass } from 'class-transformer';
import CrmAppBar from '@/components/crm/app-bar.vue';
import { InjectionIdEnum } from '@/enums/injection-id.enum';
import { UserTypeEnum } from '@/enums/crm/user-type.enum';
import DataGridFilter from '@/components/data-grid-filter.vue';
import DateRangeFilter from '@/components/date-range-filter.vue';
import dayjs from '@/plugins/dayjs';
import SettingsService from '@/services/crm/settings.service';
import ContactService from '@/services/crm/contact.service';
import SettingsModel from '@/models/crm/settings.model';
import UserContactInfo from '@/models/crm/user-contact-info.model';
import ActivityService from '@/services/crm/activity.service';
import UserModel from '@/models/user.model';
import { IDateRangeConfig } from '@/interfaces/date-range-config.interface';
import { DateHelper } from '@/utils/helpers/date-helper';
import { AttendantFilterHelper } from '@/utils/helpers/attendant-filter-helper';
import Tooltip from '@/components/tooltip.vue';
import ConversationService from '@/services/crm/conversation.service';
import ConversationDepartmentModel from '@/models/crm/conversation-department.model';
import HistoryTypeModel from '@/models/crm/history-type.model';
import AgGridWrapper from '@/components/ag-grid-wrapper.vue';
import { IGridConfig } from '@/interfaces/grid-config.interface';
import ConversationModel from '@/models/crm/conversation.model';
import { GridHelper } from '@/utils/helpers/grid-helper';
import ContentDialog from '@/components/content-dialog.vue';
import { IDialogConfig } from '@/interfaces/dialog-config.interface';
import { IKeyValue } from '@/interfaces/key-value.interface';
import { IGridCellEvent } from '@/interfaces/grid-cell-clicked.interface';
import CrmChatHistoryMessagesViewer from '../../components/crm/chat-history-messages-viewer.vue';
import CrmEvoTalksChatHistoryViewer from '../../components/crm/crm-evotalks-chat-history-viewer.vue';
import ConversationTemplateModel from '@/models/crm/conversation-template.model';
import CRMEvoTalksService from '@/services/crm/evotalks.service';
import EvoTalksConversaResumoModel from '@/models/crm/evotalks-conversa-resumo.model';
import EvoTalksConversaFilterModel from '@/models/crm/evotalks-conversa-filter.model';
import EvoTalksFilaModel from '@/models/crm/evotalks-fila.model';
import EvoTalksAgenteModel from '@/models/crm/evotalks-agente.model';

type DataGridFilterConfig = {
  periodType: PeriodTypeEnum;
  period: (Date | undefined)[];
  status: StatusEnum | null;
  contactType: ContactTypeEnum[] | null;
  classification: ClassificationEnum[] | null;
  originType: number[] | null;
  template: number[] | null;
  contactName: string | null;
  contactNumber: string | null;
  department: ConversationDepartmentModel[] | null;
  attendant: number[] | null;
  historyType: HistoryTypeModel[] | null;
  protocolNumber: string | null;
  onlyWithProtocolNumber: boolean;
};

type EvoTalksFilterConfig = {
  periodType: PeriodTypeEnum;
  period: (Date | undefined)[];
  status: string | null;
  idFilaEvo: string | null;
  tipoCanal: string | null;
  idAtendenteGeo: number | null;
  numeroTelefone: string | null;
  protocolo: string | null;
  conteudo: string | null;
  nomeContato: string | null;
  tipoContato: string | null;
  apenasComProtocolo: boolean;
};

enum IntegrationTypeEnum {
  WhatsApp360 = 'WHATSAPP_360',
  EvoTalks = 'EVOTALKS',
}

enum PeriodTypeEnum {
  OpenDate = 'OPEN_DATE',
  StartDate = 'START_DATE',
  ClosingDate = 'CLOSING_DATE',
}

enum StatusEnum {
  Open = 'OPEN',
  Closed = 'CLOSED',
}

enum ContactTypeEnum {
  Client = 'CLIENT',
  Prospect = 'PROSPECT',
  Undefined = 'UNDEFINED',
}

enum ClassificationEnum {
  Mistake = 'MISTAKE',
  Justified = 'JUSTIFIED',
  None = 'NONE',
}

enum OriginTypeEnum {
  Active = 2,
  Receptive = 1,
  Transfer = 3,
}

enum NumberTypeEnum {
  Homologado = 1,
  GeoChat = 2,
}

interface ISelectOption<T> {
  code: T;
  description: string;
}

@Component({
  components: {
    DataGridFilter,
    DateRangeFilter,
    CrmAppBar,
    AgGridWrapper,
    AgGridVue,
    Tooltip,
    ContentDialog,
    CrmChatHistoryMessagesViewer,
    CrmEvoTalksChatHistoryViewer,
  },
})
export default class CrmChatReport extends Vue {
  @inject(InjectionIdEnum.CrmSettingsService)
  private settingsService!: SettingsService;

  @inject(InjectionIdEnum.CrmContactService)
  private contactService!: ContactService;

  @inject(InjectionIdEnum.CrmActivityService)
  private activityService!: ActivityService;

  @inject(InjectionIdEnum.CrmConversationService)
  private conversationService!: ConversationService;

  @inject(InjectionIdEnum.CRMEvoTalksService)
  private evoTalksService!: CRMEvoTalksService;

  settings: SettingsModel | null = null;

  userContactInfo: UserContactInfo | null = null;

  dialogConfig: IKeyValue<IDialogConfig> = {
    history: {
      show: false,
      conversation: null,
    },
    export: {
      show: false,
      exportAll: false,
      exportCurrent: true,
    },
  };

  // #region Grid

  grid: GridReadyEvent | null = null;

  gridClient: GridReadyEvent | null = null;

  gridSettings: IGridConfig = {
    loading: false,
    itemsPerPage: 30,
    columnDefs: [
      GridHelper.getSelectionColDef({ headerCheckboxSelection: false }),
      {
        headerName: `${this.$t('crm.view.chatReport.grid.number')}`,
        colId: 'cellphone',
        field: 'numeroCanalVendas',
        minWidth: 140,
        maxWidth: 140,
        flex: 0.8,
        sortable: false,
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.numberType')}`,
        colId: 'cellphone',
        field: 'tipoCanal',
        minWidth: 140,
        maxWidth: 140,
        flex: 0.8,
        sortable: false,
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.openDate')}`,
        colId: 'openDate',
        field: 'dataInclusao',
        minWidth: 130,
        maxWidth: 130,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const date = params.data.dataInclusao;
          return DateHelper.formatToIsoDateTimeString(date);
        },
        valueFormatter: (params: ValueFormatterParams): string => {
          if (params.value && params.value !== 'Invalid Date') {
            return DateHelper.formatToLocale(params.value, 'dateTime');
          }
          return '';
        },
        cellClass: 'dateISO',
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.startDate')}`,
        colId: 'startDate',
        field: 'dataInicio',
        minWidth: 150,
        maxWidth: 150,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const date = params.data.dataInicio;
          return DateHelper.formatToIsoDateTimeString(date);
        },
        valueFormatter: (params: ValueFormatterParams): string => {
          if (params.value && params.value !== 'Invalid Date') {
            return DateHelper.formatToLocale(params.value, 'dateTime');
          }
          return '';
        },
        cellClass: 'dateISO',
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.closeDate')}`,
        colId: 'closeDate',
        field: 'dataFechamento',
        minWidth: 130,
        maxWidth: 130,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const date = params.data.dataFechamento;
          return DateHelper.formatToIsoDateTimeString(date);
        },
        valueFormatter: (params: ValueFormatterParams): string => {
          if (params.value && params.value !== 'Invalid Date') {
            return DateHelper.formatToLocale(params.value, 'dateTime');
          }
          return '';
        },
        cellClass: 'dateISO',
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.lastAttendance')}`,
        colId: 'lastAttendance',
        field: 'dataUltimaMensagem',
        minWidth: 130,
        maxWidth: 130,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const date = params.data.dataUltimaMensagem || params.data.dataInicio || params.data.dataInclusao;
          return DateHelper.formatToIsoDateTimeString(date);
        },
        valueFormatter: (params: ValueFormatterParams): string => {
          if (params.value && params.value !== 'Invalid Date') {
            return DateHelper.formatToLocale(params.value, 'dateTime');
          }
          return '';
        },
        cellClass: 'dateISO',
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.detailConversation')}`,
        colId: 'detailConversation',
        field: 'detalhar',
        cellClass: 'cell-grid-link',
        cellRenderer: () => '<span class="v-icon  mdi mdi-eye-outline theme--light"></span>',
        minWidth: 120,
        cellStyle: {
          'justify-content': 'center',
        },
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.contactType')}`,
        colId: 'contactType',
        field: 'tipo',
        minWidth: 120,
        maxWidth: 120,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const isRowPinned = params.node && params.node.rowPinned;
          if (!isRowPinned) {
            const type = params.data.tipo || 'UNDEFINED';
            return this.$t(`crm.view.chatReport.filter.${type.toLowerCase()}`).toString();
          }
          return '';
        },
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.classification')}`,
        colId: 'classification',
        field: 'engano',
        minWidth: 120,
        maxWidth: 160,
        sortable: false,
        valueGetter: (params: ValueGetterParams): string => {
          const isRowPinned = params.node && params.node.rowPinned;
          if (!isRowPinned) {
            if (params.data?.engano === 1) {
              return this.$t('crm.view.chatReport.filter.mistake').toString();
            }
            if (params.data?.outraJustificativaFechamento === 1) {
              return this.btnCloseNotSavingContact;
            }
            return this.$t('crm.view.chatReport.filter.noClassification').toString();
          }
          return '';
        },
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.originType')}`,
        colId: 'OriginType',
        field: 'origemConversa',
        minWidth: 120,
        maxWidth: 120,
        sortable: false,
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.template')}`,
        colId: 'Template',
        field: 'templateConversa',
        minWidth: 210,
        sortable: false,
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.legalName')}`,
        colId: 'legalName',
        sortable: false,
        minWidth: 200,
        valueGetter: (params: ValueGetterParams): string => {
          const isRowPinned = params.node && params.node.rowPinned;
          if (!isRowPinned) {
            if (params.data.tipo === 'CLIENT') {
              return params.data?.cliente?.nome || params.data?.cliente?.nomeFantasia;
            }
            if (params.data.tipo === 'PROSPECT') {
              return params.data?.prospect?.razaoSocial || params.data?.prospect?.nome;
            }
          }
          return '';
        },
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.cnpj')}`,
        colId: 'cnpj',
        field: 'cnpj',
        minWidth: 130,
        maxWidth: 130,
        flex: 0.8,
        sortable: false,
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.cellPhone')}`,
        colId: 'cellphone',
        field: 'numeroWhatsapp',
        minWidth: 120,
        maxWidth: 120,
        flex: 0.8,
        sortable: false,
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.contactName')}`,
        colId: 'contactName',
        field: 'contato.nome',
        minWidth: 150,
        flex: 0.8,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const isRowPinned = params.node && params.node.rowPinned;
          if (!isRowPinned) {
            return params.data?.contato?.nome || params.data.numeroWhatsapp;
          }
          return '';
        },
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.protocol')}`,
        colId: 'protocol',
        field: 'protocolo',
        cellClass: 'cell-grid-link',
        minWidth: 160,
        maxWidth: 160,
        sortable: true,
        sortingOrder: ['asc', 'desc'],
        valueFormatter: (params) => {
          if (params.value) {
            return params.value.replace('(', '').replace(')', '');
          }
          return params.value;
        },
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.attendant')}`,
        colId: 'attendant',
        field: 'atendente.nome',
        minWidth: 120,
        flex: 0.5,
        sortable: true,
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.department')}`,
        colId: 'department',
        field: 'departamento.nome',
        minWidth: 120,
        flex: 0.5,
        sortable: true,
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.historyType')}`,
        colId: 'historyType',
        field: 'tipoHistorico.nome',
        minWidth: 150,
        flex: 0.8,
        sortable: true,
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.screeningHistory')}`,
        colId: 'screeningHistory',
        field: 'historicoTriagem',
        cellClass: 'cell-grid-link',
        minWidth: 150,
        sortable: true,
      },
    ],
  };

  whatsAppColumnDefs = [...this.gridSettings.columnDefs];

  serverSideDatasource: IServerSideDatasource = {
    getRows: this.getRows,
  };

  items: ConversationModel[] = [];

  itemsClient: ConversationModel[] = [];

  selected: ConversationModel[] = [];

  // #endregion

  // #region filters

  filterOpen = 1;

  multipleFilterChanged = false;

  predefinedPeriodRanges: IDateRangeConfig[] = this.getDateRanges();

  filters: DataGridFilterConfig = {
    periodType: PeriodTypeEnum.OpenDate,
    period: [dayjs().startOf('month').toDate(), dayjs().toDate()],
    status: null,
    contactType: null,
    classification: null,
    originType: [OriginTypeEnum.Active, OriginTypeEnum.Receptive, OriginTypeEnum.Transfer],
    template: null,
    contactName: null,
    contactNumber: null,
    department: null,
    attendant: null,
    historyType: null,
    protocolNumber: null,
    onlyWithProtocolNumber: false,
  };

  totalRows = 0;

  isExporting = false;

  periodTypeOptions: ISelectOption<PeriodTypeEnum>[] = [];

  statusOptions: ISelectOption<StatusEnum>[] = [];

  contactTypeOptions: ISelectOption<ContactTypeEnum>[] = [];

  classificationOptions: ISelectOption<ClassificationEnum>[] = [];

  originTypeOptions: ISelectOption<OriginTypeEnum>[] = [];

  templateOptions: ConversationTemplateModel[] = [];

  departmentOptions: ConversationDepartmentModel[] = [];

  attendantOptions: UserModel[] = [];

  historyTypeOptions: HistoryTypeModel[] = [];

  numberTypeOptions: ISelectOption<NumberTypeEnum>[] = [];

  // #region EvoTalks

  activeIntegration: IntegrationTypeEnum = IntegrationTypeEnum.WhatsApp360;

  evoTalksFilters: EvoTalksFilterConfig = {
    periodType: PeriodTypeEnum.OpenDate,
    period: [dayjs().startOf('month').toDate(), dayjs().toDate()],
    status: null,
    idFilaEvo: null,
    tipoCanal: null,
    idAtendenteGeo: null,
    numeroTelefone: null,
    protocolo: null,
    conteudo: null,
    nomeContato: null,
    tipoContato: null,
    apenasComProtocolo: false,
  };

  evoTalksFilaOptions: EvoTalksFilaModel[] = [];

  evoTalksAgenteOptions: EvoTalksAgenteModel[] = [];

  evoTalksFiltersLoaded = false;

  evoTalksColumnDefs = [
    GridHelper.getSelectionColDef({ headerCheckboxSelection: false }),
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.protocol')}`,
      colId: 'protocol',
      field: 'protocolo',
      cellClass: 'cell-grid-link',
      minWidth: 160,
      maxWidth: 160,
      sortable: true,
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.status')}`,
      colId: 'status',
      field: 'status',
      minWidth: 100,
      maxWidth: 100,
      sortable: true,
      valueFormatter: (params: ValueFormatterParams): string => {
        if (params.value === 'ABERTA') return 'Aberto';
        if (params.value === 'FECHADA') return 'Fechado';
        return params.value || '';
      },
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.phoneNumber')}`,
      colId: 'phoneNumber',
      field: 'numeroTelefone',
      minWidth: 140,
      maxWidth: 140,
      sortable: false,
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.contactName')}`,
      colId: 'contactName',
      field: 'nomeContato',
      minWidth: 180,
      sortable: true,
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.startDate')}`,
      colId: 'startDate',
      field: 'dataInicio',
      minWidth: 150,
      maxWidth: 150,
      sortable: true,
      valueGetter: (params: ValueGetterParams): string => {
        const date = params.data?.dataInicio;
        return DateHelper.formatToIsoDateTimeString(date);
      },
      valueFormatter: (params: ValueFormatterParams): string => {
        if (params.value && params.value !== 'Invalid Date') {
          return DateHelper.formatToLocale(params.value, 'dateTime');
        }
        return '';
      },
      cellClass: 'dateISO',
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.closeDate')}`,
      colId: 'closeDate',
      field: 'dataFechamento',
      minWidth: 150,
      maxWidth: 150,
      sortable: true,
      valueGetter: (params: ValueGetterParams): string => {
        const date = params.data?.dataFechamento;
        return DateHelper.formatToIsoDateTimeString(date);
      },
      valueFormatter: (params: ValueFormatterParams): string => {
        if (params.value && params.value !== 'Invalid Date') {
          return DateHelper.formatToLocale(params.value, 'dateTime');
        }
        return '';
      },
      cellClass: 'dateISO',
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.lastMessageDate')}`,
      colId: 'lastMessageDate',
      field: 'ultimaMensagemData',
      minWidth: 150,
      maxWidth: 150,
      sortable: true,
      valueGetter: (params: ValueGetterParams): string => {
        const date = params.data?.ultimaMensagemData;
        return DateHelper.formatToIsoDateTimeString(date);
      },
      valueFormatter: (params: ValueFormatterParams): string => {
        if (params.value && params.value !== 'Invalid Date') {
          return DateHelper.formatToLocale(params.value, 'dateTime');
        }
        return '';
      },
      cellClass: 'dateISO',
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.detailConversation')}`,
      colId: 'detailConversation',
      field: 'detalhar',
      cellClass: 'cell-grid-link',
      cellRenderer: () => '<span class="v-icon mdi mdi-eye-outline theme--light"></span>',
      minWidth: 120,
      cellStyle: {
        'justify-content': 'center',
      },
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.attendant')}`,
      colId: 'attendant',
      field: 'atendente',
      minWidth: 150,
      sortable: true,
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.queue')}`,
      colId: 'queue',
      field: 'fila',
      minWidth: 150,
      sortable: true,
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.companyName')}`,
      colId: 'companyName',
      field: 'nomeEmpresa',
      minWidth: 180,
      sortable: true,
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.cnpj')}`,
      colId: 'cnpj',
      field: 'cnpj',
      minWidth: 150,
      maxWidth: 160,
      sortable: false,
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.contactType')}`,
      colId: 'contactType',
      field: 'tipoContato',
      minWidth: 140,
      maxWidth: 160,
      sortable: true,
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.conversationType')}`,
      colId: 'conversationType',
      field: 'tipoConversa',
      minWidth: 130,
      maxWidth: 160,
      sortable: true,
      valueFormatter: (params: ValueFormatterParams): string => {
        if (params.value === 'ATIVA') return 'Ativa';
        if (params.value === 'RECEPTIVA') return 'Receptiva';
        if (params.value === 'TRANSFERIDA') return 'Transferida';
        return params.value || '';
      },
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.endReason')}`,
      colId: 'endReason',
      field: 'endReason',
      minWidth: 150,
      sortable: false,
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.endReasonObs')}`,
      colId: 'endReasonObs',
      field: 'endReasonObs',
      minWidth: 300,
      sortable: false,
      cellStyle: {
        'white-space': 'normal',
        'line-height': '1.4',
        display: '-webkit-box',
        '-webkit-line-clamp': '2',
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
      },
    },
  ];

  // #endregion

  // #endregion

  async mounted(): Promise<void> {
    const loader = this.$loading.show();
    try {
      await this.loadFilterOptions();
      this.settings = await this.settingsService.getSettings();
      this.userContactInfo = await this.contactService.getLoggedUserContactInfo();
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      loader.hide();
    }
    if (this.settings?.flagUtilizaEvoTalks && this.isEvoTalksMode) {
      this.loadEvoTalksFilterOptions();
    }
  }

  onIntegrationChange(): void {
    if (this.isEvoTalksMode) {
      this.gridSettings.columnDefs = this.evoTalksColumnDefs;
      this.loadEvoTalksFilterOptions();
    } else {
      this.gridSettings.columnDefs = this.whatsAppColumnDefs;
    }
    this.applyFilter();
  }

  get isEvoTalksMode(): boolean {
    return this.activeIntegration === IntegrationTypeEnum.EvoTalks;
  }

  private async loadEvoTalksFilterOptions(): Promise<void> {
    if (this.evoTalksFiltersLoaded) return;
    try {
      const [filas, agentes] = await Promise.all([
        this.evoTalksService.getFilas(),
        this.evoTalksService.getAgentes(),
      ]);
      this.evoTalksFilaOptions = filas;
      this.evoTalksAgenteOptions = agentes;
      this.evoTalksFiltersLoaded = true;
    } catch (err) {
      this.$notify.error(`Erro ao carregar filtros EvoTalks: ${(err as Error)?.message || err}`);
    }
  }

  private async getRows(params: IServerSideGetRowsParams) {
    if (this.isEvoTalksMode) {
      return this.getRowsEvoTalks(params);
    }
    return this.getRowsWhatsApp(params);
  }

  private async getRowsEvoTalks(params: IServerSideGetRowsParams) {
    const page = this.isExporting ? 1 : (params.request.endRow || 1) / (this.gridSettings.itemsPerPage || 1);

    try {
      this.evoTalksFilters.period[0] = dayjs(this.evoTalksFilters.period[0]).startOf('day').toDate();
      this.evoTalksFilters.period[1] = dayjs(this.evoTalksFilters.period[1]).endOf('day').toDate();

      const filter = new EvoTalksConversaFilterModel();
      filter.tipoPeriodo = this.evoTalksFilters.periodType || null;
      filter.dataInicio = this.evoTalksFilters.period[0] || null;
      filter.dataFim = this.evoTalksFilters.period[1] || null;
      filter.status = this.evoTalksFilters.status || null;
      filter.idFilaEvo = this.evoTalksFilters.idFilaEvo || null;
      filter.tipoCanal = this.evoTalksFilters.tipoCanal || null;
      filter.idAtendenteGeo = this.evoTalksFilters.idAtendenteGeo || null;
      filter.numeroTelefone = this.evoTalksFilters.numeroTelefone || null;
      filter.protocolo = this.evoTalksFilters.protocolo || null;
      filter.conteudo = this.evoTalksFilters.conteudo || null;
      filter.nomeContato = this.evoTalksFilters.nomeContato || null;
      filter.tipoContato = this.evoTalksFilters.tipoContato || null;
      filter.apenasComProtocolo = this.evoTalksFilters.apenasComProtocolo || false;

      const response = await this.evoTalksService.queryConversations(
        page,
        this.isExporting ? -1 : this.gridSettings.itemsPerPage || 1,
        filter,
      );

      this.totalRows = response.total;

      params.success({
        rowData: response.results,
        rowCount: response.total,
      });

      if (this.isExporting && this.gridClient) {
        this.gridClient.api.setRowData(response.results);
        this.gridClient.api.exportDataAsExcel({
          onlySelected: false,
          allColumns: true,
          author: 'IBtech',
          sheetName: 'Conversas EvoTalks',
          fileName: `evotalks_conversas_${dayjs().format('YYYY-MM-DD_HHmmss')}.xlsx`,
        });
      }
      this.gridClient?.api.setRowData([]);
      this.isExporting = false;
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
      params.fail();
    }
  }

  private async getRowsWhatsApp(params: IServerSideGetRowsParams) {
    const sortMapping = {
      openDate: 'c.inclusaoData',
      startDate: 'c.dataInicio',
      closeDate: 'c.dataFechamento',
      lastAttendance: 'c.dataUltimaMensagem',
      contactType: 'c.tipo',
      contactName: 'c.contato.nome',
      protocol: 'c.protocolo',
      attendant: 'c.atendente.nome',
      department: 'c.departamento.nome',
      historyType: 'c.tipoHistorico.nome',
    };

    const page = this.isExporting ? 1 : (params.request.endRow || 1) / (this.gridSettings.itemsPerPage || 1);
    let orderBy: string | undefined;

    if (params.request.sortModel?.length) {
      const mappedSort = params.request.sortModel.map((x) => `${sortMapping[x.colId]} ${x.sort}`);

      orderBy = mappedSort.join(', ');
    }

    try {
      this.filters.period[0] = dayjs(this.filters.period[0]).startOf('day').toDate();
      this.filters.period[1] = dayjs(this.filters.period[1]).endOf('day').toDate();
      if (this.settings === null) this.settings = await this.settingsService.getSettings();
      if (this.userContactInfo === null) this.userContactInfo = await this.contactService.getLoggedUserContactInfo();

      if (this.userContactInfo !== null && !this.notNormalUser) {
        this.filters.attendant = [this.userContactInfo.id];
      }

      const response = await this.conversationService.queryConversations(
        page,
        this.isExporting ? -1 : this.gridSettings.itemsPerPage || 1,
        this.filters as unknown,
        orderBy,
      );

      this.totalRows = response.total;
      response.results = response.results.map((x) => {
        if (x.protocolo) {
          return {
            ...x,
            protocolo: `(${x.protocolo})`,
          } as ConversationModel;
        }
        return {
          ...x,
          protocolo: 'Sem protocolo',
        } as ConversationModel;
      });

      params.success({
        rowData: response.results,
        rowCount: response.total,
      });

      if (this.isExporting && this.gridClient) {
        const onlySelected = false;
        this.gridClient.api.setRowData(response.results);
        this.gridClient.api.exportDataAsExcel({
          onlySelected,
          allColumns: true,
          author: 'IBtech',
          sheetName: 'Conversas',
          fileName: ConversationService.generateConversationReportExportFilename(new Date()),
        });
      }
      this.gridClient?.api.setRowData([]);
      this.isExporting = false;
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
      params.fail();
    }
  }

  onFilterChange(type: string): void {
    if (type === 'multiple' && !this.multipleFilterChanged) {
      return;
    }

    this.applyFilter();
  }

  async applyFilter(): Promise<void> {
    this.multipleFilterChanged = false;

    try {
      if (this.grid?.api) {
        this.grid.api.deselectAll();
        this.selected = [];

        this.grid.api.paginationGoToFirstPage();
        this.grid.api.refreshServerSideStore({});
      }
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    }
  }

  onSelectionChanged(change: SelectionChangedEvent, selected: ConversationModel[]): void {
    this.selected = selected;
  }

  onExport(): void {
    this.dialogConfig.export.show = true;
  }

  onExportConfirm(selected: ConversationModel[]): void {
    if (this.grid) {
      if (this.dialogConfig.export.exportAll) {
        this.isExporting = true;
        const loader = this.$loading.show();
        try {
          this.grid.api.purgeServerSideCache();
        } catch (err) {
          this.$notify.error(err && (err as Error).message);
        } finally {
          loader.hide();
        }
      } else {
        const onlySelected = !!selected.length && this.items.length !== selected.length;
        const columnKeys = this.gridSettings.columnDefs
          .filter((x) => !x.checkboxSelection)
          .map((x) => x.colId || x.field || '');
        this.grid.api.exportDataAsExcel({
          onlySelected,
          columnKeys,
          allColumns: true,
          author: 'IBtech',
          sheetName: 'Conversas',
          fileName: ConversationService.generateConversationReportExportFilename(new Date()),
        });
      }
    }
    this.dialogConfig.export.show = false;
  }

  onExportAllChange(): void {
    if (this.dialogConfig.export.exportAll) {
      this.dialogConfig.export.exportCurrent = false;
    }
  }

  onExportCurrentChange(): void {
    if (this.dialogConfig.export.exportCurrent) {
      this.dialogConfig.export.exportAll = false;
    }
  }

  async onCellClick(event: IGridCellEvent<ConversationModel>): Promise<void> {
    if (this.isEvoTalksMode) {
      if (event?.colDef?.colId === 'protocol' || event?.colDef?.colId === 'detailConversation') {
        const resumo = event.data as unknown as EvoTalksConversaResumoModel;
        if (resumo) {
          this.dialogConfig.history.show = true;
          this.dialogConfig.history.conversation = resumo;
        }
      }
      return;
    }

    if (!event.data || event?.colDef?.colId !== 'protocol') {
      if (event?.colDef?.colId === 'detailConversation') {
        this.openHistoryConversationDialog(plainToClass(ConversationModel, event.data));
      }
      return;
    }

    this.openHistoryConversationDialog(plainToClass(ConversationModel, event.data));
  }

  openHistoryConversationDialog(conversation: ConversationModel): void {
    if (!conversation) {
      return;
    }

    this.dialogConfig.history.show = true;
    this.dialogConfig.history.conversation = conversation;
  }

  onCloseHistoryDialogClose(): void {
    this.dialogConfig.history.show = false;
    this.dialogConfig.history.conversation = false;
  }

  onCloseExportDialogClose(): void {
    this.dialogConfig.export.show = false;
    this.dialogConfig.export.exportAll = false;
    this.dialogConfig.export.exportCurrent = true;
  }

  get btnCloseNotSavingContact(): string {
    const res = this.$route.query.btnFecharConversaSemSalvarContato;
    if (res) {
      return res.toString();
    }
    return '';
  }

  get activeFilters(): number {
    let active = 0;
    const filtersToIgnore: string[] = [];
    const filterKeys = Object.keys(this.filters);

    if (this.userContactInfo !== null && !this.notNormalUser) {
      filtersToIgnore.push('attendant');
    }

    filterKeys.forEach((key) => {
      const filter = this.filters[key];
      if (key === 'period') {
        const validDates = filter.filter((date) => date && !Number.isNaN(new Date(date).getTime()));
        if (validDates.length === 0) {
          return;
        }
      }
      switch (key) {
        default:
          if (!filtersToIgnore.includes(key) && filter && !(isArray(filter) && !filter.length)) {
            active += 1;
          }
      }
    });

    return active;
  }

  get historyDialogTitle(): string {
    if (this.isEvoTalksMode) {
      const resumo = this.dialogConfig.history.conversation as unknown as EvoTalksConversaResumoModel;
      const protocol = resumo?.protocolo || resumo?.chatId || '';
      return this.$t('crm.view.chatReport.dialog.history.title', { protocol }).toString();
    }
    const protocol = (this.dialogConfig.history.conversation as ConversationModel)?.protocolo;
    return this.$t('crm.view.chatReport.dialog.history.title', { protocol }).toString();
  }

  get exportDialogTitle(): string {
    return this.$t('crm.view.chatReport.dialog.export.title').toString();
  }

  get notNormalUser(): boolean {
    return AttendantFilterHelper.isAttendantFilterAvailable(this.settings, this.userContactInfo);
  }

  get evoTalksAgentFilterAvailable(): boolean {
    return this.settings?.loggedUserType !== UserTypeEnum.Normal;
  }

  get activeEvoTalksFilters(): number {
    let active = 0;
    if (this.evoTalksFilters.status) active += 1;
    if (this.evoTalksFilters.idFilaEvo) active += 1;
    if (this.evoTalksFilters.tipoCanal) active += 1;
    if (this.evoTalksFilters.idAtendenteGeo) active += 1;
    if (this.evoTalksFilters.numeroTelefone) active += 1;
    if (this.evoTalksFilters.protocolo) active += 1;
    if (this.evoTalksFilters.nomeContato) active += 1;
    if (this.evoTalksFilters.tipoContato) active += 1;
    if (this.evoTalksFilters.apenasComProtocolo) active += 1;
    const validDates = (this.evoTalksFilters.period || []).filter(
      (date) => date && !Number.isNaN(new Date(date).getTime()),
    );
    if (validDates.length > 0) active += 1;
    return active;
  }

  get evoTalksStatusOptions(): ISelectOption<string>[] {
    return [
      {
        code: 'ABERTA',
        description: this.$t('crm.view.chatReport.filter.open').toString(),
      },
      {
        code: 'FECHADA',
        description: this.$t('crm.view.chatReport.filter.closed').toString(),
      },
    ];
  }

  get evoTalksPeriodTypeOptions(): ISelectOption<PeriodTypeEnum>[] {
    return [
      {
        code: PeriodTypeEnum.OpenDate,
        description: this.$t('crm.view.chatReport.filter.openDate').toString(),
      },
      {
        code: PeriodTypeEnum.ClosingDate,
        description: this.$t('crm.view.chatReport.filter.closingDate').toString(),
      },
    ];
  }

  // eslint-disable-next-line class-methods-use-this
  get evoTalksTipoContatoOptions(): ISelectOption<string>[] {
    return [
      { code: 'CLIENTE', description: 'Cliente' },
      { code: 'PROSPECT', description: 'Prospect' },
    ];
  }

  get evoTalksTipoCanalOptions(): ISelectOption<string>[] {
    return [
      {
        code: 'WAGS',
        description: this.$t('crm.view.chatReport.evoTalksFilter.tipoCanalHomologado').toString(),
      },
      {
        code: 'WAMD2',
        description: this.$t('crm.view.chatReport.evoTalksFilter.tipoCanalGeochat').toString(),
      },
    ];
  }

  queueTypeBadgeLabel(type: string | null | undefined): string {
    if (type === 'WAGS') return this.$t('crm.view.chatReport.evoTalksFilter.tipoCanalHomologado').toString();
    if (type === 'WAMD2') return this.$t('crm.view.chatReport.evoTalksFilter.tipoCanalGeochat').toString();
    return type || '';
  }

  // eslint-disable-next-line class-methods-use-this
  queueTypeBadgeColor(type: string | null | undefined): string {
    if (type === 'WAGS') return 'success';
    if (type === 'WAMD2') return 'info';
    return 'grey';
  }

  private async loadFilterOptions(): Promise<void> {
    this.periodTypeOptions = this.getPeriodTypes();
    this.statusOptions = this.getStatusOptions();
    this.contactTypeOptions = this.getContactTypeOptions();
    this.classificationOptions = this.getClassificationOptions();
    this.originTypeOptions = this.getOriginTypeOptions();
    this.numberTypeOptions = this.getNumberTypeOptions();

    const tasks = [
      this.getDepartments().then((result) => {
        this.departmentOptions = result;
      }),
      this.getAttendants().then((result) => {
        this.attendantOptions = result;
      }),
      this.getHistoryTypes().then((result) => {
        this.historyTypeOptions = result;
      }),
      this.getTemplates().then((result) => {
        this.templateOptions = result;
      }),
    ];

    await Promise.all(tasks);
  }

  private getPeriodTypes(): ISelectOption<PeriodTypeEnum>[] {
    return [
      {
        code: PeriodTypeEnum.OpenDate,
        description: this.$t('crm.view.chatReport.filter.openDate').toString(),
      },
      {
        code: PeriodTypeEnum.StartDate,
        description: this.$t('crm.view.chatReport.filter.startDate').toString(),
      },
      {
        code: PeriodTypeEnum.ClosingDate,
        description: this.$t('crm.view.chatReport.filter.closingDate').toString(),
      },
    ];
  }

  private getStatusOptions(): ISelectOption<StatusEnum>[] {
    return [
      {
        code: StatusEnum.Open,
        description: this.$t('crm.view.chatReport.filter.open').toString(),
      },
      {
        code: StatusEnum.Closed,
        description: this.$t('crm.view.chatReport.filter.closed').toString(),
      },
    ];
  }

  private getContactTypeOptions(): ISelectOption<ContactTypeEnum>[] {
    return [
      {
        code: ContactTypeEnum.Client,
        description: this.$t('crm.view.chatReport.filter.client').toString(),
      },
      {
        code: ContactTypeEnum.Prospect,
        description: this.$t('crm.view.chatReport.filter.prospect').toString(),
      },
      {
        code: ContactTypeEnum.Undefined,
        description: this.$t('crm.chatListItem.contact.notLocated').toString(),
      },
    ];
  }

  private getClassificationOptions(): ISelectOption<ClassificationEnum>[] {
    const res = [
      {
        code: ClassificationEnum.Mistake,
        description: this.$t('crm.view.chatReport.filter.mistake').toString(),
      },
    ];
    if (this.btnCloseNotSavingContact !== '') {
      res.push({
        code: ClassificationEnum.Justified,
        description: this.btnCloseNotSavingContact,
      });
    }
    res.push({
      code: ClassificationEnum.None,
      description: this.$t('crm.view.chatReport.filter.noClassification').toString(),
    });
    return res;
  }

  private getOriginTypeOptions(): ISelectOption<OriginTypeEnum>[] {
    return [
      {
        code: OriginTypeEnum.Active,
        description: this.$t('crm.view.chatReport.filter.activeConversation').toString(),
      },
      {
        code: OriginTypeEnum.Receptive,
        description: this.$t('crm.view.chatReport.filter.receptiveConversation').toString(),
      },
      {
        code: OriginTypeEnum.Transfer,
        description: this.$t('crm.view.chatReport.filter.transferConversation').toString(),
      },
    ];
  }

  private getNumberTypeOptions(): ISelectOption<NumberTypeEnum>[] {
    return [
      {
        code: NumberTypeEnum.Homologado,
        description: this.$t('crm.view.chats.filter.homologated').toString(),
      },
      {
        code: NumberTypeEnum.GeoChat,
        description: this.$t('crm.view.chats.filter.geochat').toString(),
      },
    ];
  }

  private async getDepartments(): Promise<ConversationDepartmentModel[]> {
    return this.conversationService.getDepartments();
  }

  private async getAttendants(): Promise<UserModel[]> {
    return this.activityService.getAttendants();
  }

  private async getHistoryTypes(): Promise<HistoryTypeModel[]> {
    return sortBy(await this.activityService.getHistoryTypes(), 'nome');
  }

  private async getTemplates(): Promise<ConversationTemplateModel[]> {
    return sortBy(await this.conversationService.getTemplates(), 'waTemplateName');
  }

  private getDateRanges(): IDateRangeConfig[] {
    return [
      {
        name: `${this.$t('global.today')}`,
        ...DateHelper.getTodayPeriod(),
      },
      {
        name: `${this.$t('global.yesterday')}`,
        ...DateHelper.getYesterdayPeriod(),
      },
      {
        name: `${this.$t('global.currentMonth')}`,
        ...DateHelper.getCurrentMonthPeriod(),
      },
      {
        name: `${this.$t('global.lastMonth')}`,
        ...DateHelper.getLastMonthsPeriod(1),
      },
      {
        name: `${this.$t('global.lastThreeMonths')}`,
        ...DateHelper.getLastMonthsPeriod(3),
      },
      {
        name: `${this.$t('global.lastSixMonths')}`,
        ...DateHelper.getLastMonthsPeriod(6),
      },
      {
        name: `${this.$t('global.lastYear')}`,
        ...DateHelper.getLastYearsPeriod(1),
      },
      {
        name: `${this.$t('global.currentYear')}`,
        ...DateHelper.getCurrentYearPeriod(),
      },
    ];
  }
}
